import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Re-export formatters for backward compatibility
export { formatCurrency, formatCurrencyWhole, formatPercentage, formatMultiple, formatDateTime } from './formatters';
import { formatCurrency } from './formatters';

export function formatForeignCurrency(amount: number, currency: string): string {
  // Foreign income is stored as actual currency amount, not pennies
  const value = amount;
  
  switch (currency) {
    case "US$":
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(value);
    case "Euro":
      return new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: "EUR",
      }).format(value);
    case "Other":
      return value.toLocaleString("en-GB", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    default:
      return formatCurrency(amount * 100); // Convert to pennies for GBP formatting
  }
}

export function parseCurrency(value: string): number {
  // Remove currency symbols and commas, then convert to pennies
  const cleanValue = value.replace(/[£,\s]/g, "");
  const pounds = parseFloat(cleanValue);
  return isNaN(pounds) ? 0 : Math.round(pounds * 100);
}

export function clamp(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max);
}
